// header js

document.addEventListener("DOMContentLoaded", () => {
  // const header = document.querySelector(".header");

  // const updateHeaderStyle = () => {
  //   if (window.scrollY > 5) {
  //     header.style.backgroundColor = "white";
  //     header.style.color = "black";
  //     header.classList.add('header_border')
  //       if (window.location.pathname !== "/") {
  //         header.classList.add('fixed')
  //         header.classList.add('show')
  //       }
  //   } else {
  //     header.style.backgroundColor = "";
  //     header.style.color = "";
  //     header.classList.remove('header_border')
  //         if (window.location.pathname !== "/") {
  //           header.classList.remove('fixed')
  //           header.classList.remove('show')
  //         }
  //   }
  // };

  // updateHeaderStyle();
  // document.addEventListener("scroll", updateHeaderStyle);


const header = document.querySelector(".header");
const placeholder = document.querySelector(".header-placeholder");

const updateHeaderStyle = () => {
  if (!header) return;
  if (window.scrollY > 5) {
    header.style.backgroundColor = "white";
    header.style.color = "black";
    header.classList.add('header_border');

    // if (window.location.pathname !== "/") {
    //   placeholder.style.height = `${header.offsetHeight}px`;
    //   header.classList.add('fixed');

    //   // Trigger transform after a frame
    //   requestAnimationFrame(() => {
    //     header.classList.add('show');
    //   });
    // }
  } else {
    header.style.backgroundColor = "";
    header.style.color = "";
    header.classList.remove('header_border');

    // if (window.location.pathname !== "/") {
    //   header.classList.remove('show');

    //   header.addEventListener("transitionend", () => {
    //     header.classList.remove('fixed');
    //     placeholder.style.height = "0";
    //   }, { once: true });
    // }
  }
};

updateHeaderStyle();
document.addEventListener("scroll", updateHeaderStyle);

  
});

//  ////////////   header js /////////////////

const seleCtor = document.querySelector(".country-selector");
const dropDown = document.querySelector(".country-dropdown");

if (seleCtor && dropDown) seleCtor.addEventListener("click", () => {
  if (getComputedStyle(dropDown).display === "none") {
    dropDown.style.display = "block";
  } else {
    dropDown.style.display = "none";
  }
});
document.addEventListener("click", (event) => {
  if (dropDown && seleCtor && !dropDown.contains(event.target) && !seleCtor.contains(event.target)) {
    dropDown.style.display = "none";
  }
});
// footer
let selected_country = document.querySelector('.contry_li_item #selected_country')
let all_countries = document.querySelectorAll('.contry_li_item .country-dropdown li a')


if (selected_country) all_countries.forEach(country=>{
  country.addEventListener('click',function(e){
    e.preventDefault()
    let newSelectedCounrty = this.textContent
    selected_country.textContent = ''
    selected_country.textContent = newSelectedCounrty
    selected_country.dataset.country = newSelectedCounrty
  })
})


// Cart drawer interactions are centralized in cart.js.

// ---------------------------------javascript code for mobile links -----------------------------

const links = document.querySelectorAll(".nav-mobile-link");

if (links.length > 0) {
  links[0].classList.add("active");
}

links.forEach((link) => {
  link.addEventListener("click", function (event) {
    links.forEach((l) => l.classList.remove("active"));

    this.classList.add("active");
  });
});

const humberIcon = document.querySelector(".humberger-icon");
const menu = document.querySelector(".nav-overlay");
const closeIcons = document.querySelector(".close__icon");

if (humberIcon && menu) humberIcon.addEventListener("click", () => {
  menu.classList.add("open");
  document.body.classList.add("no-scrool");
});

if (closeIcons && menu) closeIcons.addEventListener("click", () => {
  menu.classList.remove("open");
  document.body.classList.remove("no-scrool");

  document
    .querySelectorAll(".nav-overlay__menu_container")
    .forEach((menu) => (menu.style.left = "100%"));
  document
    .querySelectorAll(".nav-overlay-tertairy-containery")
    .forEach((menu) => (menu.style.left = "200%"));

  const primaryMenu = document.querySelector(".nav-overlay--primary-menu");
  if (primaryMenu) primaryMenu.style.transform = "translateX(0)";

  const backButton = document.querySelector(".nav-overlay__back");
  if (backButton) {
    backButton.style.opacity = "0";
    backButton.style.pointerEvents = "none";
  }
  document.dispatchEvent(new Event('voyage:reset-mobile-nav'));
});

document.addEventListener("DOMContentLoaded", function () {
  const arrowIcons = document.querySelectorAll(".overlay-icon");
  const sublinkIcons = document.querySelectorAll(".sublink__icon");
  const primaryMenu = document.querySelector(".nav-overlay--primary-menu");
  const subMenuContainers = document.querySelectorAll(
    ".nav-overlay__menu_container"
  );
  const tertiaryContainers = document.querySelectorAll(
    ".nav-overlay-tertairy-containery"
  );
  const backButton = document.querySelector(".nav-overlay__back");

  let backClickCount = 0;
  let activeSubmenu = null;
  let activeTertiary = null;
  if (!primaryMenu || !backButton) return;
  document.addEventListener('voyage:reset-mobile-nav', () => {
    backClickCount = 0;
    activeSubmenu = null;
    activeTertiary = null;
  });

  // Open Submenu
  arrowIcons.forEach((icon) => {
    icon.addEventListener("click", function () {
      const targetId = this.closest("li").getAttribute("data-targat");
      if (!targetId) return;

      activeSubmenu = document.getElementById(targetId);

      if (activeSubmenu) {
        subMenuContainers.forEach((menu) => (menu.style.left = "100%")); // Hide other submenus
        activeSubmenu.style.left = "0";
      }

      primaryMenu.style.transform = "translateX(-100%)";
      backButton.style.opacity = "1";
      backButton.style.pointerEvents = "auto";
      backClickCount = 0;
    });
  });

  // Open Tertiary Menu
  sublinkIcons.forEach((icon) => {
    icon.addEventListener("click", function () {
      const targetId = this.closest("li").getAttribute("data-targat");
      if (!targetId) return;

      activeTertiary = document.getElementById(targetId);

      if (activeTertiary) {
        tertiaryContainers.forEach((menu) => (menu.style.left = "200%")); // Hide other tertiary menus
        activeTertiary.style.left = "0";
      }

      if (activeSubmenu) activeSubmenu.style.left = "-100%";
      primaryMenu.style.transform = "translateX(-100%)";
      backClickCount = 0;
    });
  });

  // Back Button Behavior
  backButton.addEventListener("click", function () {
    if (backClickCount === 0) {
      if (activeTertiary) activeTertiary.style.left = "100%";
      if (activeSubmenu) activeSubmenu.style.left = "0";
      backClickCount++;
    } else {
      if (activeTertiary) activeTertiary.style.left = "200%";
      if (activeSubmenu) activeSubmenu.style.left = "100%";
      primaryMenu.style.transform = "translateX(0)";
      backClickCount = 0;
      backButton.style.opacity = "0";
      backButton.style.pointerEvents = "none";
    }
  });
});

// search popup javascript code

document.addEventListener("DOMContentLoaded", function () {
  let searchContainers = document.querySelectorAll(
    ".header-search-desktop, .header-search"
  );
  let searchPopup = document.querySelector(".search-popup");
  let headerWrapper = document.querySelector(".header-wrapper");

  if (searchContainers.length > 0 && searchPopup) {
    searchContainers.forEach((container) => {
      container.addEventListener("mouseover", function () {
        searchPopup.classList.add("active");
        headerWrapper.classList.add("active");
        document.body.style.overflow = "hidden";
      });

      container.addEventListener("mouseout", function () {
        searchPopup.classList.remove("active");
        headerWrapper.classList.remove("active");
        document.body.style.overflow = "";
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let searchPopup = document.querySelector(".search-popup");
  let headerWrapper = document.querySelector(".header-wrapper");
  let searchIconMobile = document.querySelector(".search-icon-mobile");

  if (searchPopup && headerWrapper && searchIconMobile) {
    // Click per search popup show karega
    searchIconMobile.addEventListener("click", function (event) {
      event.stopPropagation(); // Prevent click from closing it immediately
      searchPopup.classList.add("active");
      headerWrapper.classList.add("active");
      document.body.style.overflow = "hidden";
    });

    // Kisi bhi aur jaga click hone par search popup hide ho jayega
    document.addEventListener("click", function (event) {
      if (
        !searchPopup.contains(event.target) &&
        !searchIconMobile.contains(event.target)
      ) {
        searchPopup.classList.remove("active");
        headerWrapper.classList.remove("active");
        document.body.style.overflow = "";
      }
    });
  }
});

//   end search popup code

// Legacy cart handlers removed; assets/cart.js owns all cart mutations.

document.querySelectorAll(".nav-item").forEach((item) => {
  item.addEventListener("mouseenter", function () {
    let childNav = this.querySelector(".child-nav-items");
    if (childNav) {
      childNav.classList.add("open");
      document.body.style.overflow = "hidden";
      document.querySelector(".header-wrapper")?.classList.add("active");
    }
  });

  item.addEventListener("mouseleave", function () {
    let childNav = this.querySelector(".child-nav-items");
    if (childNav) {
      childNav.classList.remove("open");
    }

    if (!document.querySelector(".child-nav-items.open")) {
      document.body.style.overflow = "";
      document.querySelector(".header-wrapper")?.classList.remove("active");
    }
  });
});
